import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { Autobind } from "../autobind.decorator/autobind.decorator";
import { Logger } from "../logger/logger";
import { ErrorHandlingUtilities } from "../utilities/error-handling-utilities";
import { AdaptError } from "./adapt-error";

type Throwable = string | Error | AdaptError;

@Injectable()
export class AdaptErrorHandler implements ErrorHandler {
    private readonly log = Logger.getLogger("app");

    @Autobind
    public handleError(exception: Throwable): void {
        let error;

        // Handle Zone.js wrapped error: https://github.com/angular/angular/issues/27840
        // Should be able to be removed once issue fixed.
        if (this.isZoneJsWrappedError(exception)) {
            exception = exception.rejection;
        }

        if (exception instanceof AdaptError) {
            error = exception;
        } else if (exception instanceof Error) {
            error = AdaptError.fromError(exception);
        } else if ((exception as any) instanceof HttpErrorResponse) {
            error = new AdaptError(ErrorHandlingUtilities.getHttpResponseMessage(exception));
        } else {
            error = new AdaptError(exception);
        }

        if (error.shouldBeLogged) {
            this.log.error(error.message, error);
        }
    }

    private isZoneJsWrappedError(error: any): error is { rejection: Throwable } {
        return error instanceof Object && !!error.rejection;
    }
}
